export default __webpack_public_path__ + "static/media/Jessica Zhang.d8c9a336.png";